import React, { Component } from "react";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import { Subscription } from "lakshya-shared";
import CourseModule from "..";

const PAGE_SIZE = 10;

type PropType = {
  toggleModal: () => void;
  openDuplicateModal: (id: string) => void;
  module: CourseModule;
  user?: any;
  refreshKey?: number;
};

export default class CourseListing extends Component<PropType, any> {
  private fetchTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(props: PropType) {
    super(props);

    this.state = {
      data: [],
      pages: 1,
      loading: true,
      page: 0,
      search: "",
    };
    this.onFetchData = this.onFetchData.bind(this);
    this.handleFetch = this.handleFetch.bind(this);
  }

  handleFetch(page: number = 0, search: string = "") {
    this.setState({ loading: true });
    this.props.module.services
      .getAllCourse({ page, limit: PAGE_SIZE, search })
      .then((response: any) => {
        this.setState({
          data: response?.courses || [],
          pages: response?.pages || 1,
          page: response?.page ?? page,
          search,
          loading: false,
        });
      })
      .catch((e) => {
        this.setState({ loading: false });
        this.props.module.showError(
          "Fetching course failed",
          e.message ? e.message : "Network error",
          true
        );
      });
  }

  onFetchData(state: any) {
    const titleFilter = (state.filtered || []).find(
      (f: any) => f.id === "title"
    );
    const search = titleFilter?.value ? String(titleFilter.value).trim() : "";
    const searchChanged = search !== this.state.search;
    const page = searchChanged ? 0 : state.page || 0;

    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }

    this.fetchTimeout = setTimeout(
      () => {
        this.handleFetch(page, search);
      },
      searchChanged && search ? 400 : 0
    );
  }

  componentDidUpdate(prevProps: PropType) {
    if (
      prevProps.refreshKey !== this.props.refreshKey &&
      this.props.refreshKey !== undefined
    ) {
      this.handleFetch(this.state.page, this.state.search);
    }
  }

  componentWillUnmount() {
    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }
  }

  render() {
    const { toggleModal, openDuplicateModal, user } = this.props;
    const { data, pages, loading } = this.state;
    const isMarketingAccount = Boolean(user?.roles?.includes("marketing"));

    return (
      <>
        <div className="px-3">
          <div className="sticky-button-wrapper py-4 pr-3 d-flex justify-content-between align-items-center">
            <h4>Course Manager</h4>
            <button
              onClick={toggleModal}
              className="add-course-button-wrapper px-5 py-3"
            >
              Add Course
            </button>
          </div>
          <ReactTable
            manual
            data={data}
            minRows={3}
            defaultPageSize={PAGE_SIZE}
            pageSizeOptions={[PAGE_SIZE]}
            page={this.state.page}
            pages={pages}
            loading={loading}
            onFetchData={this.onFetchData}
            columns={[
              {
                Header: "Title",
                accessor: "title",
                filterable: true,
                Cell: (row) =>
                  isMarketingAccount === true ? (
                    <span className="text-success">{row.value}</span>
                  ) : (
                    <Link
                      className="text-success"
                      rel="noopener noreferrer"
                      to={`/admin/courses/editor/${row.original._id}`}
                    >
                      {row.value}
                    </Link>
                  ),
              },
              {
                Header: "Status",
                accessor: "isPublished",
                width: 120,
                filterable: false,
                Cell: (row) => {
                  return (
                    <span
                      className={`${
                        row.value === true
                          ? "text-success"
                          : "text-danger font-weight-bold"
                      }`}
                    >
                      {row.value === true ? "Published" : "Unpublished"}
                    </span>
                  );
                },
              },
              {
                Header: "Id",
                accessor: "_id",
                filterable: false,
                Cell: (row) => {
                  const value: string = row.value;
                  if (value && value !== "") {
                    return value;
                  } else {
                    return <span className="text-muted">N/A</span>;
                  }
                },
              },
              {
                Header: "Subscription",
                accessor: "courseRateCard",
                filterable: false,
                Cell: (row) => {
                  const subscription: Subscription = row.value;
                  if (subscription) {
                    return (
                      <Link
                        target="_blank"
                        className="text-success"
                        rel="noopener noreferrer"
                        to={`/admin/subscriptions/editor/${
                          (subscription as any)._id
                        }`}
                      >
                        {subscription.title}
                        <i className="fas fa-external-link-alt ml-3"></i>
                      </Link>
                    );
                  } else {
                    return <span className="text-muted">No Associations</span>;
                  }
                },
              },
              {
                Header: "Promotions",
                accessor: "cmsTags",
                filterable: false,
                Cell: (row) => {
                  const cmsTags: string[] = row.value;
                  if (cmsTags) {
                    return cmsTags.join(", ");
                  } else {
                    return <span className="text-muted">Disabled</span>;
                  }
                },
              },
              {
                Header: "Actions",
                accessor: "_id",
                filterable: false,
                Cell: (row) => {
                  return (
                    <button
                      onClick={() => openDuplicateModal(row.original._id)}
                      style={{ border: "none", borderRadius: 5 }}
                      className="btn-primary px-3 py-1"
                    >
                      Duplicate course
                    </button>
                  );
                },
              },
            ]}
          />
        </div>
      </>
    );
  }
}
